<template>
    <div
        ref="swiperWrapper"
        class="relative h-full w-full"
    >
        <div
            ref="swiperEl"
            class="swiper h-full w-full"
        >
            <div class="swiper-wrapper">
                <slot />
            </div>

            <div class="swiper-scrollbar" />
        </div>

        <slot name="navigation" />
    </div>
</template>

<script setup>
    import Swiper from 'swiper'
    import {
        EffectFade,
        EffectCards,
        EffectCreative,
        Autoplay,
        Navigation,
        Pagination,
        Grid,
        Thumbs,
        FreeMode,
    } from 'swiper/modules'
    // import Swiper and modules styles
    import 'swiper/css'
    // import 'swiper/css/navigation'
    import 'swiper/css/effect-fade'
    import 'swiper/css/effect-cards'
    import 'swiper/css/pagination'
    import 'swiper/css/grid'
    import 'swiper/css/thumbs'
    import 'swiper/css/effect-creative'

    const emit = defineEmits(['init', 'autoplay-time-left', 'slide-change'])

    const props = defineProps({
        options: Object,
    })

    const swiper = ref(null)

    const swiperWrapper = ref(null)
    const swiperEl = ref(null)

    onMounted(() => {
        // grab swiper elements based on class
        const swiperPagination = swiperWrapper.value.querySelector('.swiper-pagination')
        const swiperButtonPrev = swiperWrapper.value.querySelector('.button-prev')
        const swiperButtonNext = swiperWrapper.value.querySelector('.button-next')

        // init Swiper:
        swiper.value = new Swiper(swiperEl.value, {
            modules: [
                Autoplay,
                EffectFade,
                EffectCards,
                EffectCreative,
                Navigation,
                Pagination,
                Grid,
                Thumbs,
                FreeMode,
            ],
            slidesPerView: 1,
            navigation: {
                prevEl: swiperButtonPrev,
                nextEl: swiperButtonNext,
            },

            ...props.options,

            // Respect an explicit loop value from the caller; default to false to avoid Swiper loop warning with insufficient slides
            loop: props.options?.loop ?? false,

            pagination: {
                el: swiperPagination,
                clickable: true,
                ...props.options?.pagination,
            },
        })

        swiper.value.on('slideChange', (event) => {
            emit('slide-change', event)
        })

        swiper.value.on('autoplayTimeLeft', (event) => {
            emit('autoplay-time-left', event)
        })

        emit('init', swiper.value)
    })

    onBeforeUnmount(() => {
        if (swiper.value) {
            swiper.value.destroy()
        }
    })

    defineExpose({
        swiper,
    })
</script>

<style>
    @reference 'tailwindcss';

    .swiper-button-lock {
        @apply hidden;
    }

    .swiper-button-disabled {
        @apply pointer-events-none opacity-50;
    }
</style>
